/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  BigNumberish,
  Overrides,
} from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type { StkETH, StkETHInterface } from "../StkETH";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_pricePerShare",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "tokenHolder",
        type: "address",
      },
    ],
    name: "AuthorizedOperator",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "operatorData",
        type: "bytes",
      },
    ],
    name: "Burned",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "operatorData",
        type: "bytes",
      },
    ],
    name: "Minted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "tokenHolder",
        type: "address",
      },
    ],
    name: "RevokedOperator",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "operatorData",
        type: "bytes",
      },
    ],
    name: "Sent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "StakingContract",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "holder",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "authorizeOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenHolder",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "operatorData",
        type: "bytes",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "defaultOperators",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "granularity",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "address",
        name: "tokenHolder",
        type: "address",
      },
    ],
    name: "isOperatorFor",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "userData",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "operatorData",
        type: "bytes",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "operatorData",
        type: "bytes",
      },
    ],
    name: "operatorBurn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "operatorData",
        type: "bytes",
      },
    ],
    name: "operatorSend",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pricePerShare",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "revokeOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "send",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_stakingContract",
        type: "address",
      },
    ],
    name: "setStakingContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "holder",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type StkETHConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: StkETHConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class StkETH__factory extends ContractFactory {
  constructor(...args: StkETHConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _pricePerShare: PromiseOrValue<BigNumberish>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<StkETH> {
    return super.deploy(_pricePerShare, overrides || {}) as Promise<StkETH>;
  }
  override getDeployTransaction(
    _pricePerShare: PromiseOrValue<BigNumberish>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_pricePerShare, overrides || {});
  }
  override attach(address: string): StkETH {
    return super.attach(address) as StkETH;
  }
  override connect(signer: Signer): StkETH__factory {
    return super.connect(signer) as StkETH__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): StkETHInterface {
    return new utils.Interface(_abi) as StkETHInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): StkETH {
    return new Contract(address, _abi, signerOrProvider) as StkETH;
  }
}
